/**
 * Created by vvurilla on 13.08.2014.
 */


import Event = createjs.Event;

export class TestCaseInfoEvent extends Event {
    public static TEST_CASE_INFO_RECEIVED: string = "testCaseInfoReceived";

    private _paramObj: Object;

    constructor(type: string, paramObj: Object, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this._paramObj = paramObj;
    }

    public get paramObj(): Object {
        return this._paramObj;
    }
}

